<script>
	import PrivacyPolicy from './PrivacyPolicy.svelte';
	import LegalNotice from './LegalNotice.svelte';


  export let togglePrivacyPolicy;
  let privacyPolicyAccepted = false;

  
  export let onClickSection;
  let formData = {
    name: undefined,
    email: undefined,
    message: undefined,
  }
  const onSubmit = async (e) => {
    e.preventDefault()
    try {
      await fetch('/', {
        method: 'POST',
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: new URLSearchParams({
          "form-name": "contact",
          ...formData
        }).toString()
      });
      console.log('Form submitted successfully');
      onClickSection('form-success');
    } catch (error) {
      alert('No se pudo enviar el formulario ahora, ¡disculpa las molestias!')
      console.log('Error submitting form', error);
    }
  }


// @TODO: Refacto layout using css grid
</script>
<div class="contact">
  <h2>Contacto</h2>
  <div class='contact-layout'>
   <div>
    <p>Puedes contactar conmigo cuando quieras:</p>
    <br/>
    <form name="contact" method="POST" data-netlify="true">
      <div class="form-field">
        <label for='name'>Tu nombre </label>
        <input bind:value={formData.name} type="text" name="name" />
      </div>

      <div class="form-field">
        <label for='email'>Email</label>
        <input bind:value={formData.email} type="email" name="email" />
      </div>

      <div class="form-field">
        <label for='message'>Mensaje</label>
        <textarea bind:value={formData.message} name="message" rows='3'></textarea>
      </div>
      <div class="form-field">
      <small class="privacy-link"><input type='checkbox' bind:checked={privacyPolicyAccepted}>
        <div>
          He leído y acepto la <a rel="nofollow" href='#privacyModal' on:click={togglePrivacyPolicy}>política de privacidad</a>
        </div>
      </small>
      <div class='privacy-info'>
      De conformidad con lo establecido por las normativas vigentes en materia de protección de datos, los datos personales facilitados voluntariamente por usted a través del presente formulario web serán tratados por NADIA BERODIA SANCHEZ como responsable del tratamiento, con la finalidad de atender su solicitud, consulta, queja o sugerencia, sin que se produzca comunicaciones o cesiones de datos y conservados durante los plazos necesarios para atender su solicitud. No se prevén cesiones o comunicaciones de datos. Puede usted ejercer los derechos de accesos, rectificación o supresión de sus datos, mediante escrito dirigido a psicologa@nadiaberodia.com, para más información al respecto, puede consultar nuestra Política de Privacidad en www.nadiaberodia.com
      </div>
      <input type="hidden" name="contact" value="contact" />
        <button on:click={onSubmit} disabled={!privacyPolicyAccepted} type="submit">Enviar</button>
      </div>
    </form>
  </div>

  <div class='contact-layout-methods'>
  <div>
   <a class='contact-method' href="mailto:psicologa@nadiaberodia.com">
      <img class="contact-method-mail" src='/images/mail.svg' alt='phone' />
      <div>psicologa@nadiaberodia.com</div>
    </a>

    <a class="contact-method phone" href='tel:611428039'>
      <div class='contact-method-images'>
        <img src='/images/phone.svg' alt='phone' />
        <img src='/images/whatsapp.svg' alt='whatsapp' />
      </div>
      <div>611 42 80 39</div>
    </a>
    <a class="contact-method linkedin" target='_blank' href='https://es.linkedin.com/in/nadia-berodia'>
      <div class='contact-method-images'>
        <img src='/images/linkedin_logo.svg' alt='phone' />
      </div>
      <div class='linkedin-caption'>Linkedin</div>
    </a>
  </div>
   
    <div class='greetings'>
      <br/>
      <p>¡Hablamos pronto!</p>
    </div>
  </div>
  </div>
  </div>
<style> 


  .contact {
    width: 100%;
  }
  .contact-layout {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 70%;
  }

  .contact-layout-methods {
    margin-top: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin-left: 100px;
  }
  .form-field {
    font-size: 18px;
    display: flex;
    flex-direction: column;
  }

  form {
    margin-bottom: 30px;
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  input, textarea {
    width: 300px;
  }


  button {
    margin-top: 10px;
    width: 100px;
  }

 .contact-method {
   width: 300px;
   font-size: 20px;
   display: flex;
   justify-content: flex-start;
   align-items: center;
   font-weight: bold;
  }

  .contact-method.phone {
    justify-content: flex-start;
  }

  .contact-method-mail {
    margin-right: 20px;
  }

.contact-method-images {
  display: flex;
}

.linkedin-caption {
  margin-left: 10px;
  margin-top: 10px;
}

.privacy-link {
  display: flex;
}
.privacy-link input {
  margin-right: 10px;
  width: initial;
}
.privacy-link a {
  text-decoration: underline;
}


.privacy-info {
  font-size: 10px;
  color: gray;
  border: 1px dotted;
  padding: 10px;
}



@media (max-width:1350px)  { 
  .contact-layout {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-left: 30px;
  }
  .contact-layout-methods {
    margin-left: initial;
  }
}


</style>